import { batch } from 'react-redux';
import { initialize } from 'redux-form';
import { CommanderThunkAction } from '@mews-commander/types';
import { Bill, BillState } from '@mews-commander/data-access';
import { getBill, getBillsByIds } from '@mews-commander/legacy-entities/src/ducks/bills';
import { openDialog } from '../../dialog/reducer';
import { BillManipulationMode } from '../constants';
import { BILL_UPDATED_REVIEW_DIALOG_NAME } from './Dialog';

type openReviewDialogProps =
    | {
          fromBills: Bill[];
          toBill: Bill;
          fromBillIds?: never;
          toBillId?: never;
          oldBillName?: string | null;
          newBillName?: string;
      }
    | {
          fromBillIds: string[];
          toBillId: string;
          fromBills?: never;
          toBill?: never;
          oldBillName?: string | null;
          newBillName?: string;
      };

const openReviewDialog =
    (
        mode: BillManipulationMode,
        { fromBillIds, toBillId, fromBills: from, toBill: to, oldBillName, newBillName }: openReviewDialogProps
    ): CommanderThunkAction =>
    (dispatch, getState) => {
        const fromBills = from || getBillsByIds(getState(), { ids: fromBillIds });
        const toBill = to || getBill(getState(), { id: toBillId });

        if (fromBills[0].ownerId === toBill?.ownerId || toBill?.state === BillState.Closed) {
            return;
        }

        batch(() => {
            dispatch(
                initialize(BILL_UPDATED_REVIEW_DIALOG_NAME, { fromBills, toBill, mode, oldBillName, newBillName })
            );
            dispatch(openDialog(BILL_UPDATED_REVIEW_DIALOG_NAME));
        });
    };

export const openChangeBillOwnerReviewDialog =
    (props: openReviewDialogProps): CommanderThunkAction =>
    (dispatch) =>
        dispatch(openReviewDialog(BillManipulationMode.MoveBill, props));

export const openMoveItemsReviewDialog =
    (props: openReviewDialogProps): CommanderThunkAction =>
    (dispatch) =>
        dispatch(openReviewDialog(BillManipulationMode.MoveItems, props));
